window.onSubmit = function(token) {
  var form = $('.ajaxForm');
  var data = form.serialize();
  // console.log(data);

  // -- Remove any existing error messages from previous attempts --
  $('html, body').animate({scrollTop: $('#body').offset().top}, 'slow');
  $('.form__notifications .success, .form__notifications .error').fadeOut();

  if ($('#g-recaptcha-response').val() !== '') {
    $.ajax({
      type: 'post',
      url: window.location.href,
      dataType: 'json',
      data: data,
      beforeSend: function(response) {
        form.find('button[type=submit]').prop('disabled', true);
      },
      success: function(response) {
        console.log(response);
        if (response.success) {
          console.log('success');
          // -- Display notifications --
          form.delay(400).fadeOut();
          $('.form__notifications .success').delay(400).fadeIn();
          setTimeout(function(){
            form[0].reset();
          }, 400);

        } else {
          console.log('error');
          // -- Display notifications --
          $('.form__notifications .error').delay(400).fadeIn();
        }
      },
      error: function(response) {
        console.log('error');
        console.log(response);
        // -- Display notifications --
        $('.form__notifications .error').delay(400).fadeIn();
      },
      complete: function(response) {
        form.find('button[type=submit]').prop('disabled', false);
      }
    });
  }
};